import React from "react";

import { WorkerIcon } from "@packages/ds";

import { getServiceIcon } from "Components/ServiceIcon/helper";

import ServiceNode from "../ServiceNode";

import * as S from "./ServiceInfoPanel.styles";

const ServiceInfoPanelTitle = ({
  currentService,
  currentWorker,
  name,
  appName
}) => {
  const workerIcon = getServiceIcon(currentWorker).iconName;

  if (!currentService && !currentWorker) return;

  return currentService ? (
    <S.Title className={`title-${name}`}>
      <ServiceNode name={currentService?.icon || name || "router"} id={name} />
      <S.ServiceName>{appName}</S.ServiceName>
    </S.Title>
  ) : (
    <S.Title className={`title-${name}`}>
      <ServiceNode name={workerIcon} id={name} />
      <S.ServiceName>{currentWorker.app}</S.ServiceName>
      <S.ServiceName>{"/"}</S.ServiceName>
      <S.IconWrapper>
        <WorkerIcon />
      </S.IconWrapper>
      <S.ServiceName>{currentWorker.displayName}</S.ServiceName>
    </S.Title>
  );
};

export default ServiceInfoPanelTitle;
